import * as React from 'react';
import { observer } from 'mobx-react';
import { IHiddenCommonProps, HiddenInput } from '../../primitives/hidden';
import { FormField } from '../../components/form-field';

export type IHiddenFieldProps = IHiddenCommonProps & { formField: FormField<string> };

@observer
export class HiddenField extends React.Component<IHiddenFieldProps, {}> {
	render() {
		const { formField, ...rest } = this.props;
		const { value } = formField;
		return (
			<HiddenInput
				{...rest}
				value={value}
			/>
		);
	}
}
